var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadCtaBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1346,
    height: 1598,
    viewBox: "0 0 1346 1598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M502.637 49.7915L502.637 749.056C502.637 762.2 497.419 774.806 488.132 784.101C478.845 793.395 466.249 798.617 453.115 798.617H49.7942C36.6835 798.617 24.1096 803.829 14.8388 813.108C5.56811 822.386 0.359863 834.97 0.359863 848.091L0.359863 1547.7C0.359863 1560.83 5.56811 1573.41 14.8388 1582.69C24.1096 1591.97 36.6835 1597.18 49.7942 1597.18H794.185C807.296 1597.18 819.87 1591.97 829.141 1582.69C838.411 1573.41 843.619 1560.83 843.619 1547.7L843.619 848.353C843.619 841.848 844.901 835.408 847.391 829.4C849.881 823.391 853.53 817.934 858.129 813.338C862.729 808.743 868.189 805.101 874.197 802.62C880.204 800.139 886.642 798.867 893.141 798.879L1296.46 798.879C1302.98 798.879 1309.44 797.588 1315.46 795.08C1321.48 792.572 1326.95 788.896 1331.54 784.265C1336.14 779.634 1339.77 774.139 1342.23 768.096C1344.7 762.053 1345.94 755.582 1345.9 749.056V49.7915C1345.91 43.2872 1344.64 36.8444 1342.16 30.8319C1339.68 24.8194 1336.04 19.3552 1331.45 14.7518C1326.86 10.1485 1321.4 6.49651 1315.4 4.00477C1309.4 1.51302 1302.96 0.230459 1296.46 0.230469L552.071 0.230469C545.572 0.230459 539.136 1.51302 533.133 4.00477C527.13 6.49651 521.676 10.1485 517.085 14.7518C512.493 19.3552 508.853 24.8194 506.374 30.8319C503.895 36.8444 502.625 43.2872 502.637 49.7915Z",
    fill: "url(#paint0_linear_3611_3292)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3611_3292",
    x1: 673.128,
    y1: 0.230469,
    x2: 673.128,
    y2: 1597.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCtaBg);
export default __webpack_public_path__ + "static/media/downloadCTABg.6304573828e46beff5a1c65c239fce2f.svg";
export { ForwardRef as ReactComponent };